export const COLOR_SWATCHES_ONHOVER = 'COLOR_SWATCHES_ONHOVER';
export const BUNDLE_COLOR_SWATCHES_ON_HOVER = 'BUNDLE_COLOR_SWATCHES_ON_HOVER';
